import { TotalStakeStepperControl } from "appworks/ui/controls/standard/stepper/total-stake-stepper-control";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";

export class PartnerConnectTotalStakeStepperControl extends TotalStakeStepperControl {
    public setEnabled(enabled: boolean) {
        const prepaidInfo = PartnerConnectManager.getGame().getWagerHelper().getPrepaidInfo();
        if (prepaidInfo?.isPrepaid) {
            super.setEnabled(false);
        } else {
            super.setEnabled(enabled);
        }
    }
}
